import { Arrays }	from "ts-base/arrays";
import { Maybe }	from "ts-base/maybe";

import * as upModel	from "@geotoura/shared/upModel";
import RouteItem = upModel.RouteItem;

import { Route }	from "@geotoura/up/model";

// NOTE added means that the last item is commited and not preliminary
// NOTE invariant: if items is empty, index always is -1
// NOTE invariant: if items is not empty, there has to be a selected item, so 0 <= index < items.length

//-----------------------------------------------------------------------------
//## constructors

export const empty:Route	= {
	items:	[],
	index:	-1,
	added:	false,
};

//-----------------------------------------------------------------------------
//## classification

export const classifyIndex	= (route:Route) => (index:number):"none"|"preliminary"|"regular"	=>
	index < 0 || index >= route.items.length			? "none"		:
	index === route.items.length - 1 && !route.added	? "preliminary"	:
	"regular";

/*
export const classifyCurrent	= (route:Route):"none"|"regular"|"preliminary"	=>
	classifyIndex(route)(route.index);
*/

//-----------------------------------------------------------------------------
//## properties

export const regularItemCount	= (route:Route):number	=>
	route.added ? route.items.length : route.items.length - 1;

//-----------------------------------------------------------------------------
//## items

// TODO route this is unsafe
export const currentItem	= (route:Route):RouteItem	=>
	route.items[route.index];

export const regularItems	= (route:Route):ReadonlyArray<RouteItem>	=>
	route.added ? route.items : Arrays.init(route.items);

export const preliminaryItem	= (route:Route):RouteItem|null	=>
	route.added ? null : Maybe.toNullable(Arrays.last(route.items));

//-----------------------------------------------------------------------------
//## modification

// TODO route this only acts on regular items and would benefit from splitting the regular items from the preliminary item
export const moveItem	= (sourceIndex:number, targetIndex:number) => (route:Route):Route	=> {
	if (sourceIndex === targetIndex)	return route;

	// do not move the item out of the route
	const lastInRoute = route.added ? route.items.length - 1 : route.items.length - 2;
	if (sourceIndex < 0 || sourceIndex > lastInRoute)	return route;
	if (targetIndex < 0 || targetIndex > lastInRoute)	return route;

	const newItems	= Arrays.moveItem(route.items)(sourceIndex, targetIndex);

	const newIndex
		=	sourceIndex === route.index ? targetIndex
		:	sourceIndex < route.index && targetIndex >= route.index ? route.index - 1
		:	sourceIndex > route.index && targetIndex <= route.index	? route.index + 1
		:	route.index;

	const newRoute:Route	= {
		items:	newItems,
		index:	newIndex,
		added:	route.added,
	};

	return newRoute;
};
